import { useCallback, useState } from "react";

export const useModal = (initialValue = false) => {
  const [isOpen, setIsOpen] = useState(initialValue);

  const openModal = useCallback(() => setIsOpen(true), [setIsOpen]);

  const closeModal = useCallback(() => setIsOpen(false), [setIsOpen]);

  return [isOpen, openModal, closeModal];
};